<div class="contenidor">
  <img src="./assets/img/password.png" alt="">
  <div mat-dialog-title>This content is password protected.</div>
  <form [formGroup]="editMessageForm">
    <div class="input-group mb-3">
      <input class="form-control form-control-sm" type="password" width="100%" autocomplete="off" rows="5"
        formControlName="message" [value]="messageText" placeholder="Enter your password" />
    </div>

    <button class="buttonCloseEditMessage" (click)="onSubmit()" [disabled]="!editMessageForm.valid">{{
      'COMMON.ACCEPT' | translate }}</button>
  </form>
</div>